<div class="backdrop-bg" [ngClass]="{'darker': isMarker, 'backdrop-priority': priority}"
  (mousedown)="isScrollbarClick($event) && !isNotification && onClose()"></div>
<div class="backdrop" [ngClass]="priority && 'priority'"
  (mousedown)="isScrollbarClick($event) && !isNotification && onClose()">
  <div class="downloading-add" [ngClass]="isMarker && 'center'" [ngStyle]="isNotification && {'max-width': '600px'}"
    (mousedown)="$event.stopPropagation()">
    <div class="edit-bg" [ngClass]="isMarker && 'marker-container'">
      <div class="d-flex justify-content-between">
        <div class="logo"></div>
        <div class="close-button" (mousedown)="onClose()"></div>
      </div>
      <ng-content></ng-content>
    </div>
  </div>
</div>

<!-- <div class="backdrop" (click)="isScrollbarClick($event) && !isNotification && onClose()"></div>
<div class="custom-modal">
  <div class="edit-bg" [ngClass]="isMarker && 'marker-container'">
    <div class="d-flex justify-content-between">
      <div class="logo"></div>
      <div class="close-button" (mousedown)="onClose()"></div>
    </div>
    <ng-content></ng-content>
  </div>
</div> -->